module.exports = __webpack_public_path__ + "fonts/fontello.d64f9f1.eot";